/**
 * Texto legible del calendario de una fiesta local (fechas ISO YYYY-MM-DD o legado mes/día).
 * @param {{ nombre?: string; fechaInicio?: string; fechaFin?: string; mes?: string|number; dia?: string|number }} f
 */
export function formatFiestaLocalRango(f) {
  if (!f) return '';
  const fi = typeof f.fechaInicio === 'string' ? f.fechaInicio.trim() : '';
  const ffRaw = typeof f.fechaFin === 'string' ? f.fechaFin.trim() : '';
  const ff = ffRaw || fi;
  if (fi) {
    const optsDayMonth = { day: 'numeric', month: 'short' };
    const optsFull = { day: 'numeric', month: 'short', year: 'numeric' };
    try {
      const d1 = new Date(`${fi}T12:00:00`);
      const d2 = new Date(`${ff}T12:00:00`);
      if (Number.isNaN(d1.getTime())) return '';
      if (!ffRaw || fi === ff) {
        return d1.toLocaleDateString('es-ES', optsFull);
      }
      const sameYear = d1.getFullYear() === d2.getFullYear();
      return `${d1.toLocaleDateString('es-ES', sameYear ? optsDayMonth : optsFull)} — ${d2.toLocaleDateString(
        'es-ES',
        optsFull,
      )}`;
    } catch {
      return '';
    }
  }
  if (f.mes != null && String(f.mes).trim() !== '') {
    const d = f.dia != null && String(f.dia).trim() !== '' ? `${f.dia}/` : '';
    return `${d}${f.mes}`;
  }
  return '';
}
